import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
`;

export const HeaderTop = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  h2 {
    position: absolute;
    top: 15px;
    left: 10%;
    color: #1c1b3a;
    font-size: 30px;
    font: Biotif-SemiBold;
    margin-bottom: 20px;
  }
`;

export const ArrowBack = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-top: 15px;
`;

export const RightSideHeader = styled.div`
  display: flex;
  align-items: center;
  p {
    font: normal normal normal 20px/24px Biotif;
  }
  select {
    border: 0.5px solid #222247;
    border-radius: 7px;
    font: normal normal normal 20px/24px Biotif;
    option {
      background-color: #fff;
      border-radius: 6px;
      padding: 5px;
      transition: 0.3s;
      :hover {
        color: blue;
      }
    }
  }
`;

export const StyledSelect = styled.select`
  width: 100%;
  background-color: white;
  color: black;
  border: 1px solid #ccc;
  border-radius: 4px;
  font: normal normal normal 20px/24px Biotif;

  /* Apply additional styles if needed */
`;

export const ticketHeading = styled.div`
  letter-spacing: -0.26px;
  color: #1c1b3a;
  opacity: 1;
  font-size: 24px;
`;

export const ContainerDetail = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  margin: 0 auto;
  gap: 10px;
  height: 80vh;
`;

export const ConversationSection = styled.div`
  flex: 7;
  padding: 10px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 0px 6px #e3e3e3;
  border-radius: 10px;
  padding: 5px 20px;
  position: relative;
`;

export const TicketDetails = styled.div`
  flex: 3 0 1%;
  padding: 10px;
  box-sizing: border-box;
  border-left: 1px solid #ddd;
  background: #ffffff;
  box-shadow: 0px 0px 6px #e3e3e3;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;

export const Conversation = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-bottom: 10px;
`;

export const ConversationEntry = styled.div`
  margin-bottom: 10px;
  padding: 10px;
`;

export const TicketProfile = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const ProfileImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
`;

export const ProfileDetails = styled.div`
  margin-left: 10px;
`;

export const Message = styled.div`
  margin-bottom: 10px;
  font: normal normal normal 18px/20px Biotif;
  letter-spacing: 0px;
  color: #1c1b3a;
  opacity: 1;
`;

export const ReplyArea = styled.div`
  border: 0.5px solid #222247;
  border-radius: 10px;
  opacity: 1;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  bottom: 0;
  width: calc(100% - 20px);
  margin-top: 10px;
`;

export const ReplyHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const ReplyProfileImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  ProfileInitial {
    display: none;
  }
`;

export const ProfileInitial = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ddd;
  color: #333;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
`;

export const ReplyProfileDetails = styled.div`
  margin-left: 10px;
`;

export const ReplyTextarea = styled.textarea`
  width: 100%;
  height: 85px;
  padding: 10px;
  border: 1px solid #fff;
  border-radius: 4px;
  box-sizing: border-box;
  resize: none;
  margin-bottom: 10px;
`;

export const FormattingOptions = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const FormattingButton = styled.button`
  background: #fff;
  padding: 4px;
  margin-right: 5px;
  cursor: pointer;
  font-size: 14px;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: #e9e9e9;
  }
  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DiscardButton = styled.button`
  background: #fff;
  color: #1c1b3a;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  margin-right: 10px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: grey;
    color: #fff;
  }
`;

export const PostButton = styled.button`
  background: #4948ac;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background: rgb(15 14 122);
  }
`;

export const TicketDetailsTitle = styled.h2`
  letter-spacing: -0.26px;
  color: #1c1b3a;
  opacity: 1;
  font-size: 24px;
  margin: 10px;
  font: normal normal 600 18px Biotif;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TicketDetailsText = styled.div`
  font-size: 16px;
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  & > strong {
    margin-bottom: 2px;
  }
`;

export const TicketDetailsTextAns = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px;
  margin-bottom: 5px;
  margin-left: 8px;
  font: normal normal medium 16px/26px Biotif;
  & > strong {
    margin-bottom: 2px;
  }
  button {
    font-weight: 500;
    padding: 5px 5px;
    max-height: 36px;
    font-size: 14px;
    border-radius: 4px;
    font-family: Biotif;
    text-transform: initial;
    background-color: #e67e22;
  }
`;

export const RightTicketDetailsText = styled.div`
  font: normal normal normal 16px/18px Biotif;
  color: #707070;
  display: flex;
  flex-direction: row;
  margin: 5px 0px 0px 8px;
  & > strong {
    margin-bottom: 2px;
  }
`;

export const TicketDetailsEdit = styled.div`
  flex: 3 0 1%;
  padding: 10px;
  box-sizing: border-box;
  border-left: 1px solid #ddd;
  background: #ffffff;
  box-shadow: 0px 0px 6px #e3e3e3;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;

export const RightTicketDetailsDropdown = styled.div`
  font: normal normal normal 16px/18px Biotif;
  color: #707070;
  flex-direction: row;
  margin: 5px 0px 40px 8px;
  & > strong {
    margin-bottom: 2px;
  }
`;

export const SeparatorLineStraight = styled.div`
  min-height: 1.5px;
  background-color: #9399b247;
  margin-bottom: 20px;
`;

export const Separator = styled.div`
  min-height: 4vh;
`;

export const ReopenContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;
  background: #e0ebfc;
  font: normal normal bold 16px / 24px Biotif;
  border: 0.5px solid #3448ec;
  border-radius: 10px;
  margin: 10px 0px;
  p {
    margin: 0;
    flex: 1;
  }

  button {
    margin-left: auto;
    background: #4948ac;
    color: #fff;
  }
`;
